export const ltsThemeVars = {
  '--font_Merriweather': 'Merriweather',
  '--text_header': '#141414',
  '--primary_grey': '#5a6771',
  '--lts_temp_grey': '#616161',
  '--neut_dark_grey': '#6e7788',
  '--neut_dark_grey_50': 'rgba(110, 119, 136, 0.5)',
  '--secondary_DodgerBlue': '#0096fb',
  '--secondary_DodgerBlue_15': '#0096fb26',
  '--primary_dark': '#36213e',
  '--stroke_light': '#dee2e6',
  '--black_75': '#635e5f',
  '--text_black_75': 'rgba(46, 40, 42, 0.75)',
  '--ivory': '#f1f1e6',
  '--ivory_25': '#fbfbf8',
  '--ivory_50': 'rgba(241, 241, 230, 0.5)',
  '--disabled_10': 'rgba(194, 193, 201, 0.1)',
  '--disabled_15': 'rgba(194, 193, 201, 0.15)',
  '--disabled_25': 'rgba(194, 193, 201, 0.25)',
  '--disabled_50': 'rgba(194, 193, 201, 0.5)',
  '--header-drop': '0px 2px 25px rgba(0, 0, 0, 0.1)',
  '--header-drop-inset': 'inset 0px -2px -25px rgba(0, 0, 0, 0.1)',
  '--dropdown_shadow': '0px 4px 10px rgba(0, 0, 0, 0.25)',
  '--disabled': '#c2c1c9',
  '--black_50': 'rgba(46, 40, 42, 0.5)',
  '--black': '#2e282a',
  '--black_25': 'rgba(46, 40, 42, 0.25)',
  '--header_drop': '0px 2px 25px rgba(0, 0, 0, 0.1)',
  '--header_drop2': '0px 0px 5px rgba(0, 0, 0, 0.2)',
  '--backdrop_10': 'rgba(0, 0, 0, 0.1)',
  '--success': '#6cba60',
  '--success_10': 'rgba(108, 186, 96, 0.1)',
  '--success_15': 'rgba(108, 186, 96, 0.15)',
  '--success_25': '#daedd7',
  '--secondar_light_green': '#549161',
  '--error': '#bc0e33',
  '--error_10': 'rgba(188, 14, 51, 0.1)',
  '--error_15': 'rgba(188, 14, 51, 0.15)',
  '--error_20': '#f2cfd6',
  '--error_40': 'rgba(188, 14, 51, 0.4)',
  '--warning': '#d39f06',
  '--warning_10': '#d39f061a',
  '--warning_15': 'rgba(211, 159, 6, 0.15)',
  '--warning_20': '#d39f0633',
  '--warning_25': '#f4e7c0',
  '--warning_40': 'rgba(211, 159, 6, 0.4)',
  '--warning_text': '#856300',
  '--primary_5': 'rgba(11, 64, 107, 0.05)',
  '--primary_5_hex': '#f2f5f7',
  '--primary_8': '#ecf0f4',
  '--primary_10': 'rgba(11, 64, 107, 0.1)',
  '--primary_50': 'rgba(11, 64, 107, 0.5)',
  '--primary_25': 'rgba(11, 64, 107, 0.25)',
  '--primary_CTA': '#dde8f0',
  '--light_bg': '#f5faff',
  '--blue_15': '#d9efff',
  '--blue_25': 'rgba(0, 150, 251, 0.25)',
  '--state_20': '#f3e9c8',
  '--box-shadow_10': '#1018281a',
  '--box-shadow_20': '#1018280f',
  '--teal': '#00859c',
  '--teal_10': 'rgba(0, 133, 156, 0.1)',
  '--teal_20': 'rgba(0, 133, 156, 0.2)',
  '--green_20': 'rgba(205, 240, 234, 0.2)',
  '--green_40': 'rgba(205, 240, 234, 0.4)',
  '--olive_green': '#9da338',
  '--olive_green_10': 'rgba(157, 163, 56, 0.1)',
  '--teal_secondary': '#00467e',
  '--shadowBlack08': 'rgba(30, 28, 29, 0.08)',
  '--shadowBlack04': 'rgba(30, 28, 29, 0.04)',
  '--toastify-color-light': '#fff',
  '--toastify-color-dark': '#121212',
  '--toastify-color-info': 'var(--blue_15)',
  '--toastify-color-success': 'var(--success_25)',
  '--toastify-color-warning': 'var(--warning_25)',
  '--toastify-color-error': 'var(--error_20)',
  '--toastify-text-color-info': 'var(--black)',
  '--toastify-text-color-success': 'var(--black)',
  '--toastify-text-color-warning': 'var(--black)',
  '--toastify-text-color-error': 'var(--black)',
  '--gradientStartColor': '#1e3a8a',
  '--gradientEndColor': '#93c5fd',
  '--gradient_warm':
    'linear-gradient(90deg, rgba(246, 211, 101, 0.5) 0%, rgba(253, 160, 133, 0.5) 100%)',
  '--gradient_vibrant':
    'linear-gradient(105.4deg, rgba(151, 71, 255, 0.15) 0%, rgba(253, 207, 111, 0.15) 98.9%)',
  '--gradient_vibrant_2': 'linear-gradient(90deg, #fcf1ea 0%, #fbdae7 100%)',
  '--box-shadow_m': '0 0 0 1px rgba(30, 28, 29, 0.04), 0 0 5px 0 rgba(30, 28, 29, 0.08)',
  '--box-shadow_s': '0px 0px 4px 0px rgba(30, 28, 29, 0.08)',
  '--box-shadow_xl': '0 2px 24px 0 rgba(30, 28, 29, 0.1)',
  '--gradient_storm':
    'linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(198, 189, 227, 1) 100%)',
  '--gradient_corporate': 'linear-gradient(255.4deg, #ffb7b7 0%, #ffffff 100%)',
  '--gradient_tiempo_hover': 'linear-gradient(270deg, #ffbea7 0%, #ffe498 100%)',
  '--gradient_timeOff_hover': 'linear-gradient(105.4deg, #f0e1ff 0%, #ffefd5 98.9%)',
  '--gradient_noCallNoShow_hover': 'linear-gradient(90deg, #ffece1 0%, #ffc6dd 100%)',
  '--gradient_corporate_hover': 'linear-gradient(255.4deg, #ffa1a1 0%, #ffffff 100%)',
  '--gradient_stormHub_hover': 'linear-gradient(110.7deg, #ffffff -9.14%, #baa7ef 136.77%)',
  '--primary_main': '#0b406b',
  '--cta_primary': '#0B406B',
  '--cta_secondary': '#1260A0',
  '--cta_tertiary': '#5FA0D3',
  '--cta_bg': '#dae2e9',
  '--cta_disabled': '#c5d0d8',
  '--link_primary': '#00b4d9',
  '--link_secondary': '#40C7E3',
  '--link_tertiary': '#80D9EC',
  '--link_button_bg': '#e9fbff',
  '--link_disabled': '#ccdadd',
  '--black_primary': '#1e1c1d',
  '--text_primary': '#1e1c1d',
  '--black_secondary': '#626161',
  '--text_secondary': '#626161',
  '--text_tertiary': '#9a9999',
  '--text_disabled': '#c2c0c0',
  '--text_inverse': '#FFFFFF',
  '--stroke_primary': '#a0a0a0',
  '--stroke_secondary': '#d0d0d0',
  '--stroke_tertiary': '#e7e7e7',
  '--white': '#ffffff',
  '--stroke_disabled': '#d0cfcf',
  '--bg_primary': '#e5ebf0',
  '--bg_secondary': '#f3f5f8',
  '--bg_tertiary': '#f7f8fa',
  '--bg_disabled': '#F0F0F0',
  '--bg_black': '#1E1C1D',
  '--bg_white': '#FFFFFF',
  '--informational_primary': '#605374',
  '--informational_secondary': '#c2bdd6',
  '--informational_tertiary': '#f3f0ff',
  '--informational_bg': '#f7f6fb',
  '--icons_primary': '#626161',
  '--icons_disabled': '#c2c0c0',
  '--icons_inverse': '#FFFFFF',
  '--success_primary': '#2e7d32',
  '--success_secondary': '#5AC25F',
  '--success_bg': '#d5f0d7',
  '--state_error': '#bc0e32',
  '--error_secondary': '#ec123f',
  '--error_bg': '#fbcfd9',
  '--warning_primary': '#b28501',
  '--warning_secondary': '#FAD054',
  '--warning_bg': '#fdf2d1',
  '--blue_dark': '#007ca3',
  '--blue_medium': '#bfdee8',
  '--blue_light': '#e5f2f6',
  '--blue_lightest': '#F2F9FB',
  '--purple_dark': '#605374',
  '--purple_medium': '#f3f0ff',
  '--purple_light': '#f7f6fb',
  '--olive_dark': '#415526',
  '--olive_medium': '#BCC3B3',
  '--olive_light': '#eceee9',
  '--yellow_dark': '#B28501',
  '--yellow_medium': '#F2DD9E',
  '--yellow_light': '#fdf2d1',
  '--error_primary': '#bc0e32',
  '--red_medium': '#ebb7c1',
  '--red_light': '#fbcfd9',
  '--green_dark': '#2e7d32',
  '--green_medium': '#d5f0d7',
  '--green_light': '#F2FAF3',
};
export const hcfThemeVars = {
  '--font_Merriweather': 'Merriweather',

  /* ================= TEXT ================= */
  '--text_header': '#141414',
  '--text_primary': '#1e1c1d',
  '--text_secondary': '#626161',
  '--text_tertiary': '#9a9999',
  '--text_disabled': '#c2c0c0',
  '--text_inverse': '#FFFFFF',
  '--text_black_75': 'rgba(46, 40, 42, 0.75)',
  '--lts_temp_grey': '#616161',
  '--neut_dark_grey': '#6e7788',
  '--neut_dark_grey_50': 'rgba(110, 119, 136, 0.5)',
  '--ivory': '#f1f1e6',
  '--ivory_25': '#fbfbf8',
  '--ivory_50': 'rgba(241, 241, 230, 0.5)',
  '--header-drop': '0px 2px 25px rgba(0, 0, 0, 0.1)',
  '--header-drop-inset': 'inset 0px -2px -25px rgba(0, 0, 0, 0.1)',
  '--backdrop_10': 'rgba(0, 0, 0, 0.1)',
  '--secondar_light_green': '#549161',
  '--state_20': '#f3e9c8',
  '--green_20': 'rgba(205, 240, 234, 0.2)',
  '--green_40': 'rgba(205, 240, 234, 0.4)',
  '--white': '#ffffff',
  '--icons_primary': '#626161',
  '--icons_disabled': '#c2c0c0',
  '--icons_inverse': '#FFFFFF',

  /* ================= PRIMARY ================= */
  '--primary_main': '#31346F', // kept from V2
  '--primary_dark': '#36213e',
  '--primary_grey': '#5a6771',
  '--primary_5': 'rgba(11, 64, 107, 0.05)',
  '--primary_5_hex': '#f2f5f7',
  '--primary_8': '#ecf0f4',
  '--primary_10': 'rgba(11, 64, 107, 0.1)',
  '--primary_25': 'rgba(11, 64, 107, 0.25)',
  '--primary_50': 'rgba(11, 64, 107, 0.5)',
  '--primary_CTA': '#dde8f0',

  /* ================= CTA ================= */
  '--cta_primary': '#31346F',
  '--cta_secondary': '#5A5D8C',
  '--cta_tertiary': '#8385A9',
  '--cta_bg': '#D6D6E2',
  '--cta_disabled': '#ADAEC5',

  /* ================= SECONDARY ================= */
  '--secondary_DodgerBlue': '#0096fb',
  '--secondary_DodgerBlue_15': '#0096fb26',
  '--secondary_dark': '#007ca3',
  '--secondary_light': '#007ca31a',
  '--secondary_green': '#415526',
  '--secondary_green_10': 'rgba(65, 85, 38, 0.1)',

  /* ================= LINKS ================= */
  '--link_primary': '#00b4d9',
  '--link_secondary': '#40C7E3',
  '--link_tertiary': '#80D9EC',
  '--link_button_bg': '#e9fbff',
  '--link_disabled': '#ccdadd',

  /* ================= BACKGROUND ================= */
  '--bg_primary': '#e5ebf0',
  '--bg_secondary': '#f3f5f8',
  '--bg_tertiary': '#f7f8fa',
  '--bg_disabled': '#F0F0F0',
  '--bg_black': '#1E1C1D',
  '--bg_white': '#FFFFFF',
  '--light_bg': '#f5faff',

  /* ================= STROKE ================= */
  '--stroke_primary': '#a0a0a0',
  '--stroke_secondary': '#d0d0d0',
  '--stroke_tertiary': '#e7e7e7',
  '--stroke_light': '#dee2e6',
  '--stroke_disabled': '#d0cfcf',

  /* ================= BLACK SCALE ================= */
  '--black_primary': '#1e1c1d',
  '--black_secondary': '#626161',
  '--black': '#2e282a',
  '--black_25': 'rgba(46, 40, 42, 0.25)',
  '--black_50': 'rgba(46, 40, 42, 0.5)',
  '--black_75': '#635e5f',

  /* ================= DISABLED ================= */
  '--disabled': '#c2c1c9',
  '--disabled_10': 'rgba(194, 193, 201, 0.1)',
  '--disabled_15': 'rgba(194, 193, 201, 0.15)',
  '--disabled_25': 'rgba(194, 193, 201, 0.25)',
  '--disabled_50': 'rgba(194, 193, 201, 0.5)',

  /* ================= SUCCESS ================= */
  '--success': '#6cba60',
  '--success_dark': '#2e7d32',
  '--success_primary': '#2e7d32',
  '--success_secondary': '#5AC25F',
  '--success_10': 'rgba(108, 186, 96, 0.1)',
  '--success_15': 'rgba(108, 186, 96, 0.15)',
  '--success_25': '#daedd7',
  '--success_bg': '#d5f0d7',
  '--green_dark': '#2e7d32',
  '--green_medium': '#d5f0d7',
  '--green_light': '#F2FAF3',

  /* ================= ERROR ================= */
  '--error': '#bc0e33',
  '--state_error': '#bc0e32',
  '--error_primary': '#bc0e32',
  '--error_secondary': '#ec123f',
  '--error_10': 'rgba(188, 14, 51, 0.1)',
  '--error_15': 'rgba(188, 14, 51, 0.15)',
  '--error_20': '#f2cfd6',
  '--error_40': 'rgba(188, 14, 51, 0.4)',
  '--error_bg': '#fbcfd9',
  '--red_medium': '#ebb7c1',
  '--red_light': '#fbcfd9',

  /* ================= WARNING ================= */
  '--warning': '#d39f06',
  '--warning_primary': '#b28501',
  '--warning_secondary': '#FAD054',
  '--warning_text': '#856300',
  '--warning_10': '#d39f061a',
  '--warning_15': 'rgba(211, 159, 6, 0.15)',
  '--warning_20': '#d39f0633',
  '--warning_25': '#f4e7c0',
  '--warning_40': 'rgba(211, 159, 6, 0.4)',
  '--warning_bg': '#fdf2d1',
  '--yellow_dark': '#B28501',
  '--yellow_medium': '#F2DD9E',
  '--yellow_light': '#fdf2d1',

  /* ================= INFO / PURPLE ================= */
  '--informational_primary': '#605374',
  '--informational_secondary': '#c2bdd6',
  '--informational_tertiary': '#f3f0ff',
  '--informational_bg': '#f7f6fb',
  '--purple_dark': '#605374',
  '--purple_medium': '#f3f0ff',
  '--purple_light': '#f7f6fb',

  /* ================= BLUE ================= */
  '--blue_dark': '#007ca3',
  '--blue_medium': '#bfdee8',
  '--blue_light': '#e5f2f6',
  '--blue_15': '#d9efff',
  '--blue_25': 'rgba(0, 150, 251, 0.25)',

  /* ================= OLIVE ================= */
  '--olive_dark': '#415526',
  '--olive_medium': '#BCC3B3',
  '--olive_light': '#eceee9',
  '--olive_green': '#9da338',
  '--olive_green_10': 'rgba(157, 163, 56, 0.1)',

  /* ================= TEAL ================= */
  '--teal': '#00859c',
  '--teal_secondary': '#00467e',
  '--teal_10': 'rgba(0, 133, 156, 0.1)',
  '--teal_20': 'rgba(0, 133, 156, 0.2)',

  /* ================= SHADOWS ================= */
  '--shadowBlack08': 'rgba(30, 28, 29, 0.08)',
  '--shadowBlack04': 'rgba(30, 28, 29, 0.04)',
  '--box-shadow_10': '#1018281a',
  '--box-shadow_20': '#1018280f',
  '--box-shadow_s': '0px 0px 4px 0px rgba(30, 28, 29, 0.08)',
  '--box-shadow_m': '0 0 0 1px rgba(30, 28, 29, 0.04), 0 0 5px 0 rgba(30, 28, 29, 0.08)',
  '--box-shadow_xl': '0 2px 24px 0 rgba(30, 28, 29, 0.1)',
  '--header_drop': '0px 2px 25px rgba(0, 0, 0, 0.1)',
  '--header_drop_inset': 'inset 0px -2px -25px rgba(0, 0, 0, 0.1)',
  '--header_drop2': '0px 0px 5px rgba(0, 0, 0, 0.2)',
  '--dropdown_shadow': '0px 4px 10px rgba(0, 0, 0, 0.25)',

  /* ================= GRADIENTS ================= */
  '--gradientStartColor': '#1e3a8a',
  '--gradientEndColor': '#93c5fd',
  '--gradient_warm':
    'linear-gradient(90deg, rgba(246, 211, 101, 0.5) 0%, rgba(253, 160, 133, 0.5) 100%)',
  '--gradient_vibrant':
    'linear-gradient(105.4deg, rgba(151, 71, 255, 0.15) 0%, rgba(253, 207, 111, 0.15) 98.9%)',
  '--gradient_vibrant_2': 'linear-gradient(90deg, #fcf1ea 0%, #fbdae7 100%)',
  '--gradient_storm':
    'linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(198, 189, 227, 1) 100%)',
  '--gradient_corporate': 'linear-gradient(255.4deg, #ffb7b7 0%, #ffffff 100%)',
  '--gradient_tiempo_hover': 'linear-gradient(270deg, #ffbea7 0%, #ffe498 100%)',
  '--gradient_timeOff_hover': 'linear-gradient(105.4deg, #f0e1ff 0%, #ffefd5 98.9%)',
  '--gradient_noCallNoShow_hover': 'linear-gradient(90deg, #ffece1 0%, #ffc6dd 100%)',
  '--gradient_corporate_hover': 'linear-gradient(255.4deg, #ffa1a1 0%, #ffffff 100%)',
  '--gradient_stormHub_hover': 'linear-gradient(110.7deg, #ffffff -9.14%, #baa7ef 136.77%)',

  /* ================= TOASTIFY ================= */
  '--toastify-color-light': '#fff',
  '--toastify-color-dark': '#121212',
  '--toastify-color-info': 'var(--blue_15)',
  '--toastify-color-success': 'var(--success_25)',
  '--toastify-color-warning': 'var(--warning_25)',
  '--toastify-color-error': 'var(--error_20)',
  '--toastify-text-color-info': 'var(--black)',
  '--toastify-text-color-success': 'var(--black)',
  '--toastify-text-color-warning': 'var(--black)',
  '--toastify-text-color-error': 'var(--black)',
  '--blue_lightest': '#F2F9FB',
};

export function applyThemeVars(vars: Record<string, string>) {
  const root = document.documentElement;
  Object.entries(vars).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
}
export const applyLtsTheme = () => {
  applyThemeVars(ltsThemeVars);
};
export const applyHcfTheme = () => {
  applyThemeVars(hcfThemeVars);
};
